import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';


const useHrisUploadStore = create(
  devtools(
    persist(
      (set, get) => ({
        uploadId: null,
        status: null,           // PROCESSING | COMPLETE | NEEDS_ACTION | FAILED
        progress: 0,            // 0-100 percent
        processedCount: 0,
        totalRows: 0,
        mappedCount: 0,
        needsActionCount: 0,
        flaggedCount: 0,
        message: '',
        isActive: false,        // true while an upload is in-flight

       

        /**
         * Called immediately after upload API returns 200.
         * Sets the initial processing state from the upload response.
         */
        setUpload: (uploadId, totalRows) =>
          set({
            uploadId,
            status: 'PROCESSING',
            progress: 0,
            processedCount: 0,
            totalRows: totalRows || 0,
            mappedCount: 0,
            needsActionCount: 0,
            flaggedCount: 0,
            message: 'Upload received. Mapping job started.',
            isActive: true,
          }),

        /**
         * Called on each SSE progress event from the Cloud Run Job.
         * Updates live counts for the progress UI.
         */
        updateProgress: (data) =>
          set({
            progress: Number(data.progress) || 0,
            processedCount: Number(data.processed_count) || 0,
            totalRows: Number(data.total_rows) || get().totalRows,
            mappedCount: Number(data.mapped_count) || 0,
            needsActionCount: Number(data.needs_action_count) || 0,
            flaggedCount: Number(data.flagged_count) || 0,
            message: data.message || '',
            status: data.status === 'Task Completed'
              ? 'COMPLETE'
              : data.status === 'HRIS Mapping Failed'
                ? 'FAILED'
                : get().status,
          }),

        /**
         * Called when terminal state is confirmed (from SSE or BQ poll).
         * Marks the upload as no longer active — progress UI shows final state.
         */
        setTerminal: (status, data = {}) =>
          set({
            status,
            progress: 100,
            processedCount: Number(data.processed_count) || get().processedCount,
            mappedCount: Number(data.mapped_count) || get().mappedCount,
            needsActionCount: Number(data.needs_action_count) || get().needsActionCount,
            flaggedCount: Number(data.flagged_count) || get().flaggedCount,
            message: data.message || `Mapping ${status.toLowerCase()}.`,
            isActive: false,
          }),

        /**
         * Called when user views results or starts a new upload.
         * Clears persisted state so next visit starts fresh.
         */
        clearUpload: () =>
          set({
            uploadId: null,
            status: null,
            progress: 0,
            processedCount: 0,
            totalRows: 0,
            mappedCount: 0,
            needsActionCount: 0,
            flaggedCount: 0,
            message: '',
            isActive: false,
          }),
      }),
      {
        name: 'hris-upload-store', // localStorage key
      }
    ),
    { name: 'HrisUploadStore' }   // Redux DevTools label
  )
);

export default useHrisUploadStore;
